import useSWR from "swr";
import { api } from "../services";
import { PaginatedResult } from "../utils/pagination";

const BASE_URL = "/system-admin/jobopening";

export const useJobOpenings = (params) => {
  const { pageNumber = 1, pageSize = 9, search = "", type = "" } = params || {};

  const query = new URLSearchParams();

  query.append("pageNumber", pageNumber);
  query.append("pageSize", pageSize);
  if (search) query.append("search", search);
  if (type && type !== "all") query.append("type", type);

  const getPagination = async () => {
    const response = await api.getPaginated(`${BASE_URL}?${query.toString()}`);
    return new PaginatedResult(response.data, response.pagination);
  };

  const create = async (data) => {
    const jobOpenings = await api.post(BASE_URL, data);
    return jobOpenings;
  };

  const update = async (id, data) => {
    const jobOpenings = await api.patch(`${BASE_URL}/${id}/edit`, data);
    return jobOpenings;
  };

  const closeJobOpening = async (id, data) => {
    const jobOpenings = await api.patch(`${BASE_URL}/${id}/close`, data);
    return jobOpenings;
  };

  const find = async (query) => {
    const jobOpenings = await api.get(`${BASE_URL}/find?search=${query}`);
    return jobOpenings;
  };

  const getById = async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response;
  };

  return {
    getPagination,
    create,
    closeJobOpening,
    update,
    find,
    getById,
  };
};

export const useJobOpeningsById = (id) => {
  const { data, isLoading, mutate } = useSWR(id ? `${BASE_URL}/${id}` : null, api.get);

  const remove = async (id) => {
    const jobOpenings = await api.delete(`${BASE_URL}/${id}`);
    return jobOpenings;
  };

  return {
    isLoading: id ? isLoading : false,
    data,
    mutate,
    remove,
  };
};

export const useJobOpeningLogs = (id) => {
  const { data, isLoading, mutate } = useSWR(id ? `${BASE_URL}/${id}/logs` : null, api.get);

  return {
    isLoading,
    logs: data || [],
    mutate,
  };
};
